import map from 'lodash/map';

export const getOptions = (values: any[] = [], field) => {
  let options: Record<string, any>[] = [];
  map(values, each =>
    options.push({ label: each[field], value: each, key: each[field] }),
  );
  return options;
};
